import type { ILegendItems } from "app/components/React/Legends/legendsTypes";
import { useCallback, useMemo, useState } from "react";
import type { IChartData } from "../TrafficVolumesLineChart.types";

export const useChartLegend = (data: IChartData[]) => {
    const [hiddenSeries, setHiddenSeries] = useState<string[]>([]);

    const legendItems: ILegendItems = useMemo(() => {
        return data?.map((record) => {
            const isHidden = hiddenSeries.some((series) => series === record.name);

            return {
                name: record.name,
                color: record.color,
                isHidden: isHidden,
                visible: !isHidden,
            };
        });
    }, [data, hiddenSeries]);

    const handleLegendClick = useCallback(
        (legendItem: { name: string }) => {
            const isHidden = hiddenSeries.some((series) => series === legendItem.name);

            const updatedSeries = isHidden
                ? hiddenSeries.filter((series) => series !== legendItem.name)
                : [...hiddenSeries, legendItem.name];

            setHiddenSeries(updatedSeries);
        },
        [hiddenSeries, setHiddenSeries],
    );

    return {
        legendItems,
        handleLegendClick,
        hiddenSeries,
    };
};
